import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { EBBClaimProcessMasterModel } from 'src/Models/EBBClaimProcessMasterModel';
import { InrollProductsCompanyModel } from 'src/Models/InrollProductsCompanyModel';
import { LifelineNLADClaimService } from 'src/Services/nladClaim.service';
import * as FileSaver from 'file-saver';
import { I360Service } from 'src/Services/i360Service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-claim-imports-lifeline-listing',
  templateUrl: './claim-imports-lifeline-listing.component.html',
  styleUrls: ['./claim-imports-lifeline-listing.component.css']
})
export class ClaimImportsLifelineListingComponent implements OnInit {

  listOfData: EBBClaimProcessMasterModel[];
  listOfExportData: EBBClaimProcessMasterModel[]
  filterModel = new FilterModel();
  SelectedTool: string;
  productId: number = 1;
  providerId: number = 0;
  userId: number = 0;

  isAscending: boolean = false
  upDowCompanyNameCSS: string = '';
  upDowSourceFileNameCSS: string = '';
  upDowDestinationFileNameCSS: string = '';
  upDowMonthsCSS: string = '';
  upDowYearsCSS: string = '';
  upDowRecordsCountCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowErrorCountCSS: string = '';

  totalRecordsCount: number = -1;
  isloading: boolean = false;
  currentPage: number = 1;

  listOfInrollProductCompany: InrollProductsCompanyModel[];
  dropdownCompanies = [];
  selectedItemsCompanies = [];
  dropdownSettingCompanies = {};
  listOfCompany = [];
  monthText = [];

  tokenKey: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  deleteId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly titleService: Title,
    private readonly nladService: LifelineNLADClaimService,
    private readonly toastr: ToastrService,
    private readonly i360Service: I360Service,
    private readonly checkAuth: CheckAuth,
      private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Lifeline Claim Import');
    this.productId = ToolEnum[this.SelectedTool];
    this.providerId = 0;
    this.userId = this.sessionStorageService.getAdminUserId();
    this.filterModel.providerId = this.providerId.toString();
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'CreatedDate Desc';
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.GetLifelineClaimProcessMasterPaged();
    this.GetInrollClientCompany();
    this.monthText.push({ 'id': 1, 'itemName': 'January' });
    this.monthText.push({ 'id': 2, 'itemName': 'February' });
    this.monthText.push({ 'id': 3, 'itemName': 'March' });
    this.monthText.push({ 'id': 4, 'itemName': 'April' });
    this.monthText.push({ 'id': 5, 'itemName': 'May' });
    this.monthText.push({ 'id': 6, 'itemName': 'June' });
    this.monthText.push({ 'id': 7, 'itemName': 'July' });
    this.monthText.push({ 'id': 8, 'itemName': 'August' });
    this.monthText.push({ 'id': 9, 'itemName': 'September' });
    this.monthText.push({ 'id': 10, 'itemName': 'October' });
    this.monthText.push({ 'id': 11, 'itemName': 'November' });
    this.monthText.push({ 'id': 12, 'itemName': 'December' });
  }

  GetLifelineClaimProcessMasterPaged() {
    this.isloading = true;
    this.listOfData = [];
    this.filterModel.IsExport = false;
    this.nladService.GetLifelineClaimProcessMasterPagedV2(this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfData = data.listOfData;
          if (this.listOfData != null) {
            if (this.listOfData.length > 0) {
              this.totalRecordsCount = this.listOfData[0].totalRecordCount;
            }
            else {
              this.totalRecordsCount = 0;
            }
          }
          else {
            this.totalRecordsCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetLifelineClaimProcessMasterPaged();
  }

  sort(sortBy: any) {
    this.upDowCompanyNameCSS = '';
    this.upDowSourceFileNameCSS = '';
    this.upDowDestinationFileNameCSS = '';
    this.upDowMonthsCSS = '';
    this.upDowYearsCSS = '';
    this.upDowRecordsCountCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowErrorCountCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sourceFileName") {
        this.upDowSourceFileNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "destinationFileName") {
        this.upDowDestinationFileNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "months") {
        this.upDowMonthsCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "years") {
        this.upDowYearsCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "recordsCount") {
        this.upDowRecordsCountCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "errorRecordsCount") {
        this.upDowErrorCountCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sourceFileName") {
        this.upDowSourceFileNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "destinationFileName") {
        this.upDowDestinationFileNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "months") {
        this.upDowMonthsCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "years") {
        this.upDowYearsCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "recordsCount") {
        this.upDowRecordsCountCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "errorRecordsCount") {
        this.upDowErrorCountCSS = 'fa fa-arrow-up';
      }

    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.GetLifelineClaimProcessMasterPaged();
  }

  GetInrollClientCompany() {
    this.nladService.GetLifelineInrollClientCompanyV2().subscribe(
      data => {
        this.dropdownSettingCompanies = {
          singleSelection: true,
          text: 'Filter by Company',
          enableSearchFilter: true,
          classes: 'borderLessTextBoxGreen',
          badgeShowLimit: 1,
          noDataLabel: 'No company',
          showCheckbox: false,
          enableFilterSelectAll: false
        };

        if (data != null) {
          if (data.status == 'Success') {
            this.listOfInrollProductCompany = data.listofInrollCompany;
            if (this.listOfInrollProductCompany != null) {
              if (this.listOfInrollProductCompany.length > 0) {
                for (let iCounter = 0; iCounter < this.listOfInrollProductCompany.length; iCounter++) {
                  this.dropdownCompanies.push({ 'id': this.listOfInrollProductCompany[iCounter].companyId, 'itemName': this.listOfInrollProductCompany[iCounter].companyName });
                }
              }
            }
          }
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedCompanies($event) {
    this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, $event.id)
    this.listOfCompany.push($event.id);
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event.id;
    this.GetLifelineClaimProcessMasterPaged();
  }

  onDeSelectedCompanies($event) {
    if (this.listOfCompany != null) {
      if (this.listOfCompany.length > 0) {
        this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, $event.id)
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event.id;
    this.GetLifelineClaimProcessMasterPaged();
  }

  onSelectAllCompanies($event) {
    for (const item of $event) {
      if (this.listOfCompany != null) {
        if (this.listOfCompany.length > 0) {
          this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, item.id)
          this.listOfCompany.push(item.id);
        }
        else {
          this.listOfCompany.push(item.id);
        }
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event[0].id;
    this.GetLifelineClaimProcessMasterPaged();
  }

  onDeSelectAllCompanies($event) {
    this.listOfCompany = [];
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = '0';
    this.GetLifelineClaimProcessMasterPaged();
  }

  removeElemetninArrayById(array, element) {
    return array.filter(e => e.id !== element);
  }

  redirectToDetailsPage(id, companyName) {

    sessionStorage.setItem('ViewClaimMasterId', id);
    sessionStorage.setItem('ViewCompanyName', companyName);
    this.router.navigate(['/admin/inroll/view/lifeline-claim'])
  }

  setMonthsText(id) {
    if (id > 0)
      return this.monthText.filter(m => m.id == id)[0].itemName;
    return id;
  }

  downloadDocument(filePath, fileNames) {
    this.blockDocument();
    this.filterModel.docPath = filePath;
    this.filterModel.docType = 'EBBClaimFile';
    this.i360Service.DownloadDocument(this.tokenKey, this.filterModel).subscribe(
      fileData => {

        this.unblockDocument();
        if (fileNames == '') {
          this.toastr.error('Records not found.', 'Error');
        }
        else {
          if (fileData != null) {
            FileSaver.saveAs(fileData, fileNames);
          }
        }
      }, error => {
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  setDeleteId(id) {
    this.deleteId = id;
  }

  LifelineClaimDataDelete(id) {
    if (this.deleteId > 0) {
      this.blockDocument()
      this.nladService.LifelineClaimDataDelete(this.deleteId).subscribe(
        data => {
          this.deleteId = 0;
          this.unblockDocument();
          if (data.id > 0) {
            this.GetLifelineClaimProcessMasterPaged();
            this.toastr.success('Data deleted successfully', 'Delete')
          }
        }, error => {
          this.unblockDocument();
          console.log(error);
        }
      );
    }
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportLifelineClaimImport() {
    this.isloading = true;
    this.listOfExportData = [];
    this.filterModel.IsExport = true;
    this.nladService.GetLifelineClaimProcessMasterPagedV2(this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfExportData = data.listOfData;
          if (this.listOfExportData != null) {
            if (this.listOfExportData.length > 0) {
              setTimeout(() => {
                this.DownloadLifelineClaimImport();
                this.isloading = false;
              }, 2000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadLifelineClaimImport() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportInrollLifelineClaimImport';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportInrollLifelineClaimImport.xls");
  }

}
